import * as Yup from 'yup';

export const programSchema = Yup.object().shape({
    title: Yup.string().required({ name: 'title', message: 'O campo é obrigatório' }),
    tags_id: Yup.array().of(Yup.number()).optional(),
    activity_id: Yup.array().of(Yup.number()).optional(),
    status: Yup.string()
  });